<template>
    <div v-bind="$attrs" id="highchart_area_chart">
        <highcharts :options="chartOptions" ref="areaChart"></highcharts>
        <div class="highcharts-data-table">
            <table v-if="showTable" class="custom-table">
                <caption class="highcharts-table-caption"></caption>
                <thead>
                    <tr>
                        <th class="highcharts-empty"></th>
                        <!--<th class="highcharts-text">Período</th>-->
                        <th class="highcharts-text" v-for="serie in chartOptions.series" :key="serie.name">
                            {{ serie.name }}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(categoria, index) in chartOptions.xAxis.categories" :key="index">
                        <td class="highcharts-text">{{ categoria }}</td>
                        <td class="highcharts-number" v-for="serie in chartOptions.series" :key="serie.name + index">
                            {{ formatIntegerPrice(serie.data[index],2,2) }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import { i18n, tb } from '@/i18n';
import { formatIntegerPrice } from "@/Mixins/Formatting";
import * as Highcharts from 'highcharts';

/*Highcharts.setOptions({
            lang: {
            locale: "pt",
            noData: i18n.t('charts.noData'),
            exportData: {
            categoryHeader: i18n.t('charts.month'),
            },
        },
})*/
//import { Chart } from "highcharts-vue";
//import Highcharts from 'highcharts'
//import exportingInit from 'highcharts/modules/exporting'
//import offlineExporting from "highcharts/modules/offline-exporting";
//exportingInit(Highcharts)
//offlineExporting(Highcharts);
//import Highcharts from "highcharts";

//import exportingInit from "highcharts/modules/exporting";
//import stockInit from "highcharts/modules/stock";
//import offlineExporting from "highcharts/modules/offline-exporting";
//import accessibility from "highcharts/modules/accessibility";

//stockInit(Highcharts);
//exportingInit(Highcharts);
//offlineExporting(Highcharts);
//accessibility(Highcharts);
import 'highcharts/modules/exporting'
import "highcharts/modules/accessibility";
import "highcharts/modules/export-data";
import "highcharts/modules/no-data-to-display";
//import { color } from "highcharts";
//exportingInit(Highcharts)

export default {
    /*components: {
        highcharts: Chart,
    },*/
    props: {
        options: {
            type: Object,
            default: function () {
                return {};
            },
        },
        height: {
            type: String,
            default: "100%",
        },

        title: {
            type: String,
            default: "",
        },
        subtitle: {
            type: String,
            default: "",
        },
        alignTitleLeft: {
            type: Boolean,
            default: false,
        },

        curve: {
            type: String,
            default: "smooth",
        },

        series: {
            type: Array,
            default:[],
            required: true,
        },
        categories:{
            type: Array,
            required: true,
        },
        isPriceChart: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        chartOptions() {
            return {
                exporting:{
                    buttons: {
                        contextButton: {
                            menuItems: [
                                'viewFullscreen',
                                    'printChart',
                                    'separator',
                                    'downloadPNG',
                                    'downloadJPEG',
                                    'downloadSVG',
                                    'separator',
                                    'downloadCSV',
                                    //'downloadXLS',
                                    {
                                        text: this.showTable ? i18n.t('charts.hideData') : i18n.t('charts.viewData'),
                                        onclick: () => {
                                            this.showTable = !this.showTable
                                        }
                                    },
                            ]
                        }
                    }
                },
                /*exporting: {
                    buttons:{
                        contextButton:{
                             y:-30
                        }
                    }
                },*/
                /*exporting: {
                    enabled: true
                },*/
                /*responsive: {
                    rules: [
                        {
                        condition: {
                            maxWidth: 700,
                        },
                        chartOptions: {
                            chart: {
                            height: 350,
                            },
                        },
                        },
                        {
                        condition: {
                            minWidth: 700,
                        },
                        chartOptions: {
                            chart: {
                            height: 450,
                            },
                        },
                        },
                    ],
                },*/
                /*exporting: {
                    menuItemDefinitions: {
                    downloadPNG: {
                        textKey: 'downloadPNG',
                        onclick: function() {
                        this.exportChart();
                        }
                    },
                    downloadJPEG: {
                        textKey: 'downloadJPEG',
                        onclick: function() {
                        this.exportChart({
                            type: 'image/jpeg'
                        });
                        }
                    },
                    downloadPDF: {
                        textKey: 'downloadPDF',
                        onclick: function() {
                        this.exportChart({
                            type: 'application/pdf'
                        });
                        }
                    },
                    downloadSVG: {
                        textKey: 'downloadSVG',
                        onclick: function() {
                        this.exportChart({
                            type: 'image/svg+xml'
                        });
                        }
                    }
                    },
                    fallbackToExportServer:false
                },*/
                lang: {
                        locale: "pt",
                        noData: i18n.t('charts.noData'),
                        exportData: {
                        categoryHeader: i18n.t('charts.month'),
                        },
                },
                lang: {
                        locale: "pt",
                        noData: i18n.t('charts.noData'),
                        exportData: {
                            categoryHeader: i18n.t('charts.month'),
                        },
                        contextButtonTitle: i18n.t('charts.menu'),
                        downloadJPEG: i18n.t('charts.downloadJPEG'),
                        downloadPDF: i18n.t('charts.downloadPDF'),
                        downloadPNG: i18n.t('charts.downloadPNG'),
                        downloadSVG: i18n.t('charts.downloadSVG'),
                        downloadCSV: i18n.t('charts.downloadCSV'),
                        downloadXLS: i18n.t('charts.downloadXLS'),
                        viewFullscreen: i18n.t('charts.fullscreen'),
                        printChart: i18n.t('charts.print'),
                        exitFullscreen: i18n.t('charts.exitFullscreen'),
                        viewData: i18n.t('charts.viewData'),
                        loading: i18n.t('charts.loading'),
                        //noData: 'Sem dados para mostrar'
                },
                chart: {
                    type: "area",
                    marginTop: window.innerWidth<=600?60:35,
                    /*events: {
                        load: function() {
                            var chart = this,
                            barsLength = chart.series[0].data.length;
                            chart.update({
                                chart: {
                                    height: 235 + 60 * barsLength
                                }
                            }, true, false, false);
                        }
                   },*/
                   //height: 400,
                },
                title: {
                    text: "",
                    //margin:50
                    //margin: 50,
                },
                /*subtitle: {
                    text: "Total C/ Rappel Valorizado: <b> 46.390€</b> | Valor Rappel Propec: <b>11.492€</b> | Valor Líquido Compras: <b>34.898€</b>",
                    useHTML: false,
                    style: {
                    textAlign: "left",
                    },
                },*/
                //colors:['#0d94c7','#30c96f','#f5791b','#4fb4f7'],
                colors: this.colors,
                legend: {
                    margin: 5,
                },
                xAxis: {
                    //pointStart: 'Jan 2025',
                    //allowDecimals: true,
                    //minPadding:0,
                    categories: (this.categories || []).map((category) => tb(category)),
                    //crosshair: true,
                    /*[
                        "Jan 2025",
                        "Feb 2025",
                        "Mar 2025",
                        "Abr 2025",
                    ],*/
                },
                yAxis: {
                    title: {
                        text: "",
                    },
                    //tickInterval: 2500,
                    labels: {
                        style: {
                            fontSize: window.innerWidth<=600?'11px':'12px',
                        },
                        formatter: function () {
                            //return  this.value + '€'
                            if(window.innerWidth<=600){
                                if(this.value>1000){
                                    return (this.value/1000).toFixed(1) + "€"
                                }else{
                                    return this.value+ '€'
                                }
                            }else{
                                return formatIntegerPrice(this.value)
                            }
                            //Highcharts.numberFormat(this.value, 0) + "€";
                            //this.axis.defaultLabelFormatter.call(this)+'€' ;
                        },
                    },
                },
                tooltip: {
                    shared: true,
                    formatter: function () {
                    return this.points.reduce(
                        (s, point) => `${s}<br/>${point.series.name}: <b>${formatIntegerPrice(point.y,2,2)}</b>`,
                        `<b>${this.key}</b>`
                        );
                    },
                    /*pointFormat:
                        "{series.name}:  <b>{point.y:,.%0f} €</b><br/>",*/
                },
                credits: {
                    enabled: false,
                },
                plotOptions: {
                    /*lang: {
                        thousandsSep: ','
                    },*/
                    /*series: {
                        pointStart: "Jan 2025",
                    },*/

                    area: {
                        //pointStart: 'Jan 2025',
                        fillOpacity: 0.1,
                        //pointStart: 'Jan 2025',
                        marker: {
                            enabled: true,
                            symbol: "circle",
                            radius: 4,
                            states: {
                                hover: {
                                    enabled: true,
                                },
                            },
                        },
                    },
                },
                series:this.getSeries(),

            };
        },
    },
    data() {
        return {
        colors:["#006db6", "#26aaff", "#f7b305"],
        showTable:false
      };
    },
    mounted(){
        window.EventBus.$on('update:areaChart', (e) => {
            //console.log('update:areaChart',e)
            this.updateChart(e)
        })
    },
    destroyed(){
        window.EventBus.$off('update:areaChart');
    },
    methods:{
    updateChart(val) {
      //this.chartOptions.series[seriesIndex].data = newData;
            /*, function(chart){

        $('#container').resizable({
            resize: function(){
                //console.log($(this).height())
                chart.setSize( $(this).width(), $(this).find('#chart').height())
            }
        });

        });*/
      setTimeout(()=>{
        //console.log('updateChart(', this.$refs.areaChart);
            this.$refs.areaChart.chart.redraw();
      },2000)
    },
    getSeries(){
        let result=[];
        _.each(this.series,(o,i)=>{
            //console.log(' getSeries',i,o,this.colors);
            let obj={
                        pointPlacement: "on",
                        dataLabels: {
                            style:{
                                //fontFamily: 'monospace',
                                //fontSize: '1em',
                                fontWeight:'normal',
                                //color: this.colors[i],
                                textOutline:'none',
                                //border:'1px solid #e344343'
                            },
                            enabled: true,
                            //format: '{point.y:.%00f} €',
                            formatter: function () {
                                return  formatIntegerPrice(this.y,2,2)
                                // Highcharts.numberFormat(this.y, 2) + "€";
                            },
                        },
                        name: null,
                        data: [],
                    }
                    obj.name=tb(o.name)
                    obj.data=o.data
                    result.push(obj)

        })
        //console.log(' getSeries',result);
        return result
    }
  }
};
</script>

<style>
.highcharts-figure,
.highcharts-data-table table {
    min-width: 350px;
    max-width: 800px;
    margin: 1em auto;
}

.highcharts-data-table table {
    font-family: Verdana, sans-serif;
    border-collapse: collapse;
    border: 1px solid #ebebeb;
    margin: 10px auto;
    text-align: center;
    width: 100%;
    /*max-width: 700px;*/
}

.highcharts-data-table caption {
    padding: 1em 0;
    font-size: 1.2em;
    color: #555;
}

.highcharts-data-table th {
    font-weight: 600;
    padding: 0.3em;
    font-size: 0.7rem;
}

.highcharts-data-table td,
.highcharts-data-table th,
.highcharts-data-table caption {
    padding: 0.3em;
    text-align: left;
}
.highcharts-data-table td{
    text-align: left;
    font-size: 0.8rem;
}

.highcharts-data-table thead tr,
.highcharts-data-table tr:nth-child(even) {
    background: #f8f8f8;
}

.highcharts-data-table tr:hover {
    background: #f1f7ff;
}

.highcharts-description {
    margin: 0.3rem 10px;
}
</style>
